
import React from "react";

interface HoneycombBackgroundProps {
  className?: string;
  simplified?: boolean;
}

const HoneycombBackground: React.FC<HoneycombBackgroundProps> = ({ className, simplified = false }) => {
  return (
    <div className={`fixed inset-0 -z-0 overflow-hidden pointer-events-none ${className || ''}`}>
      {simplified ? (
        // Simplified version with just a subtle gradient
        <div className="absolute inset-0 bg-gradient-to-br from-white to-gray-50" />
      ) : (
        // Original honeycomb pattern with reduced opacity
        <>
          <div className="absolute inset-0">
            <svg 
              className="absolute top-0 left-0 w-full h-full opacity-[0.07]"
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              preserveAspectRatio="xMidYMid slice"
            >
              <defs>
                <pattern
                  id="honeycomb"
                  width="60"
                  height="60"
                  patternUnits="userSpaceOnUse"
                  patternTransform="scale(1.5) rotate(0)"
                >
                  <rect width="100%" height="100%" fill="transparent" />
                  <path
                    d="M30 51.96L8.04 37.5L8.04 8.04L30 0L51.96 8.04L51.96 37.5L30 51.96Z"
                    stroke="currentColor"
                    strokeWidth="1"
                    fill="none"
                    strokeOpacity="0.3"
                  />
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#honeycomb)" />
            </svg>
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-white/50" />
        </>
      )}
    </div>
  );
};

export default HoneycombBackground;
